import { Text, Button } from 'components/atomic'
import Image from 'next/legacy/image'

const UGCPanel: React.FunctionComponent = () => {
  return (
    <div id="ss6-ugc-panel" className="relative h-[450px] w-full lg:h-[670px]">
      <Image
        src="/images/deadrop/ss6_features/ss6-ugc-bg.png"
        layout="fill"
        objectFit="contain"
        objectPosition="top"
        priority
        alt="SS6 UGC Logo"
      />

      <div className="2xl::pl-80 absolute px-3 md:pl-12 lg:pl-24 xl:pl-80">
        <Text variant="h2" tag="h2" className="mt-24 w-4/5 md:mt-36 lg:mt-52 lg:w-[900px] xl:mt-64">
          Does
          <br />
          making stuff
          <br />
          get you hyped?
        </Text>
        <Text
          variant="p2"
          tag="p"
          className="mb-6 mt-4 w-4/5 text-center tracking-wide text-white/80 md:text-left lg:mb-8 xl:w-[800px]"
        >
          We are working on a dynamic new tool for creatives to make UGC...
        </Text>
        <Button href="/creative" className="!w-full md:!w-[435px]" variant="primary">
          <span>Tell Me More</span>
        </Button>
      </div>
    </div>
  )
}

export default UGCPanel
